import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { GalleryCarousel } from '../GalleryCarousel';
export function GallerySection() {
  return <section className="bg-surface px-5 py-20 md:py-28" data-id="element-129" data-mp="vomu2p2xjs8o">
      <div className="mx-auto max-w-6xl" data-id="element-130" data-mp="qwcxwrb81vxy">
        <SectionHeading title="Mirá lo que tiene" data-id="element-131" data-mp="qv1vautiiu8f" />
        <div className="mt-12" data-id="element-132" data-mp="lytlzy1zxv96">
          <GalleryCarousel data-id="element-133" data-mp="lxig9sozqdff" />
        </div>
      </div>
    </section>;
}